import { useMutation, useQueryClient } from '@tanstack/react-query';

import { changeBillingStatus } from '../api/ChangeBillingStatus';

interface ChangeBillingStatusParams {
  billingUuid: string;
  status: string;
}

export const useChangeBillingStatus = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending, isError } = useMutation({
    mutationFn: ({ billingUuid, status }: ChangeBillingStatusParams) =>
      changeBillingStatus(billingUuid, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['billings'] });
    },
  });

  return { changeStatus: mutate, isPending, isError };
};
